var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.692008 1.42959L1.03374 1.03374C2.28676 -0.219278 4.24753 -0.333189 5.62923 0.692008L6.02508 1.03374L20 15.0071L33.9749 1.03374C35.3532 -0.34458 37.5879 -0.34458 38.9663 1.03374C40.3446 2.41206 40.3446 4.64676 38.9663 6.02508L24.9929 20L38.9663 33.9749C40.2193 35.2279 40.3332 37.1887 39.308 38.5704L38.9663 38.9663C37.7132 40.2193 35.7525 40.3332 34.3708 39.308L33.9749 38.9663L20 24.9929L6.02508 38.9663C4.64676 40.3446 2.41206 40.3446 1.03374 38.9663C-0.34458 37.5879 -0.34458 35.3532 1.03374 33.9749L15.0071 20L1.03374 6.02508C-0.219278 4.77206 -0.333189 2.81129 0.692008 1.42959Z",
    fill: "#DD1818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmDeleteIcon);
export default __webpack_public_path__ + "static/media/confirm-delete-icon.39d5ff8d6c44fb6f96d38516784b3b92.svg";
export { ForwardRef as ReactComponent };